import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { NotificationService } from "src/app/notifications/notification.service";
import { UiService } from "src/app/ui/ui.service";
import { AuthService } from "../auth.service";
import {
  confirmPasswordValidator,
  passwordValidator,
} from "../auth.validators";

@Component({
  selector: 'app-activate',
  templateUrl: './activate.component.html',
  styleUrls: ['./activate.component.scss']
})
export class ActivateComponent implements OnInit {

  activateForm = new FormGroup({
    newPassword: new FormControl("", [
      Validators.required,
      passwordValidator(),
    ]),
  });
  activated = false;
  user: any;
  private onComponentDestroy = new Subject();

  constructor(
    private AuthService: AuthService,
    private Router: Router,
    private NotificationService: NotificationService,
    private route: ActivatedRoute,
    private uiService: UiService,
  ) { }

  ngOnInit(): void {
    this.user = this.route.snapshot.data.user;
    this.activateForm.addControl(
      "confirmNewPassword",
      new FormControl("", [
        Validators.required,
        confirmPasswordValidator(this.activateForm.controls.newPassword),
      ]),
    );
  }

  ngOnDestroy() {
    this.onComponentDestroy.next();
    this.onComponentDestroy.complete();
  }

  submitActivation() {
    this.uiService
      .waitForEvent(
        this.AuthService.activate(
          this.activateForm.controls.newPassword.value,
          this.user.id,
          this.route.snapshot.params.activation_token,
        ),
      )
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe(
        () => {
          this.NotificationService.openSuccessSnackBar("Activation Successful. Please log in.");
          this.activated = true;
          setTimeout(() => {
            this.Router.navigate(["auth", "login"]);
          }, 4000);
        },
        () => {
          this.NotificationService.openErrorSnackBar(
            "Error resetting password",
          );
        },
      );
    }

}
